export default __webpack_public_path__ + "static/media/lixeira.0c122225.svg";